import React from "react"
import {
  QueryCache,
  QueryClient,
  QueryClientProvider,
} from "@tanstack/react-query"
import {
  defaultReactQueryCacheOptions,
  defaultReactQueryClientOptions,
} from "@myvp/shared/src/default-react-query-client-options"
import { RootUIStateProviders } from "@myvp/shared/src/ui-providers"
import defaultDateFnsLocale from "date-fns/locale/en-US"

export const queryClient = new QueryClient({
  defaultOptions: defaultReactQueryClientOptions,
  queryCache: new QueryCache(defaultReactQueryCacheOptions),
})

/**
 * For jest test usage.
 */
export const clearQueryClient = () => {
  queryClient.clear()
}

const Providers = (props: { children?: React.ReactNode }) => {
  let ui: React.ReactNode = props.children

  ui = <RootUIProviders>{ui}</RootUIProviders>
  // any providers that need to use a queryClient (or useQuery) should go before this
  ui = <QueryClientProvider client={queryClient}>{ui}</QueryClientProvider>

  return ui
}

const RootUIProviders = (props: { children?: React.ReactNode }) => {
  return (
    <RootUIStateProviders
      // RootUIStateProviders is used to apply ThemeProvider, SetRootProperties and AlertList.
      // Any input is fine for the props here because messages, locale, rtl, are handled in messages.tsx UIProviders
      locale={"en-US"}
      updateIntl={() => {}}
      messages={{ hello: "world" }}
      dateFnsLocale={defaultDateFnsLocale}
      rtl={false}
    >
      {props.children}
    </RootUIStateProviders>
  )
}
export default Providers
